exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.user-name-with-badge[data-v-70d6c330] {\r\n    display: -webkit-inline-box;\r\n    display: -ms-inline-flexbox;\r\n    display: inline-flex;\r\n    -webkit-box-align: center;\r\n        -ms-flex-align: center;\r\n            align-items: center;\r\n    grid-gap: 0.25em;\r\n    gap: 0.25em;\n}\n.identity-validated-badge[data-v-70d6c330] {\r\n    color: #5cb85c;\r\n    font-size: 0.95em;\n}\n.identity-validated-badge i[data-v-70d6c330] {\r\n    vertical-align: middle;\n}\r\n", ""]);

// exports
